/**
 * Minimal wrapper around the Docsun WAI auth API.
 * – Caches the token + licence in sessionStorage
 * – Dispatches an `auth-ready` event so legacy code (dvm.js) can start
 */
export async function loginAndCache (email, password) {
  const payload = { email, password };

  const res  = await fetch(
    'https://wai.docsun.health/api/clientron/auth/login',
    {
      method : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body   : JSON.stringify(payload),
    }
  );

  const json = await res.json();
  if (!json.success || !json.result?.accessToken)
    throw new Error(json.message || 'Login failed');

  /* ---- store credentials for the SDK (dvm.js expects these keys) ---- */
  sessionStorage.setItem('token',   json.result.accessToken);
  sessionStorage.setItem('licence', json.result.licencekey);
  sessionStorage.setItem('status',  'true');
  sessionStorage.setItem('authReady', 'true');

  /* tell any listeners (dvm.js bootScan waits for it) */
  window.dispatchEvent(new Event('auth-ready'));

  return json.result;          // caller may want the profile later
}
